// extracted by mini-css-extract-plugin
module.exports = {"paper":"Menu_paper__1Zbv-"};